// komponent modal'a

import React, { PropsWithChildren, FC, useState } from 'react';
import MuiModal from '@mui/material/Modal';
import { X, Fullscreen, FullscreenExit } from 'react-bootstrap-icons';
import classnames from 'classnames';

import styles from 'theme/components/controls/Modal/Modal.module.scss';

// typ danych wejściowych
interface IProps {
  title: string;
  fullScreen?: boolean;
  fullWidth?: boolean;
  onClose?: () => void;
  resizable?: boolean;
  open?: boolean;
}

const Modal: FC<PropsWithChildren<IProps>> = ({
  title,
  onClose,
  children,
  fullScreen,
  fullWidth,
  resizable,
  open = true
}) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleResize = () => {
    setIsFullScreen(!isFullScreen);
  };

  return (
    <MuiModal open={open} className={'StylePath-Components-Controls-Modal'}>
      <div
        onClick={(e) => e.stopPropagation()}
        className={classnames(styles.componentWrapper, {
          [styles.fullScreen]: isFullScreen || fullScreen,
          [styles.fullWidth]: fullWidth && !isFullScreen
        })}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <div className={styles.headerActions}>
            {resizable && (
              <div className={styles.resize}>
                {isFullScreen ? (
                  <FullscreenExit size={16} onClick={handleResize} />
                ) : (
                  <Fullscreen size={16} onClick={handleResize} />
                )}
              </div>
            )}
            {!!onClose && (
              <div className={styles.close}>
                <X onClick={onClose} />
              </div>
            )}
          </div>
        </div>
        <div className={styles.modalContent}>{children}</div>
      </div>
    </MuiModal>
  );
};

export default Modal;
